module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/slide-1.1fd9cac7.webp";